<template>
    <div :class='classObj' :key='refresh'>
        <label v-if='label'>{{ label }}</label>
        <select :multiple='isMulti' :name='name' :key='getKey'  v-model='selectValue' :disabled='isDisabled' @change='validate' @blur='validate' @focus='validate'>
            <option v-for='(option, idx) in selectedOptions' :key='idx' :value='option.value'>{{option.label}}</option>
        </select>
        <span class='validationMessage'>{{ validationMessage }}</span>
    </div>
</template>

<script>
    export default{
        name: 'SelectMulti',
        props: ['name', 'store', 'options', 'label', 'validationRules', 'disabled', 'hasErrors', 'multi'],
        data(){ return {
            validationMessages: [],
            isFocused: false,
            refresh: 0
        }},
        computed:{
            selectValue: {
                get () { 
                    let test = this.$store.getters[this.$props.store + '/' + this.$props.name];
                        return  typeof test == 'string' ? [test] : test
                    },
                set (value) { return this.$store.dispatch(this.$props.store + '/set', {field: this.$props.name, value}) },
            },
            classObj(){
                return{
                    Select: true,
                    'has-error': this.valid == false || this.$props.hasErrors == true,
                    'has-success': this.valid == true,
                    'is-disabled': this.isDisabled == true,
                    'is-focused': this.isFocused == true,
                    'is-multiple': this.isMulti == true
                }
            },
            getKey(){ return this.$props.store + '_' + this.$props.name + '_' + this.refresh},
            isMulti() { return this.$props.multi || false },
            isDisabled() { return this.$props.disabled || false },
            valid(){ return this.validationMessages.length == 0 ? true : false },
            validationMessage() { return this.validationMessages.join(', ') },
            placeholder() { return this.$props.placeholder || '' },
            selectedOptions(){
                if(!this.isMulti){
                    return this.$props.options;
                }else{
                    let tempOpts = this.$props.options
                    for (const option in this.$props.options){
                        for(const values in this.selectValue){
                            tempOpts[option].selected = (Object.entries(this.selectValue).findIndex(x => x[1] == this.$props.options[option].value) == -1) ? false : true;
                        }
                    }
                    tempOpts = tempOpts.slice().sort(function(a, b) {
                        return b.selected - a.selected;
                    });
                    return tempOpts;
                    refresh++
                }
            }
        },
        methods: {
            validate(e){
                if(e.type == 'focus') this.isFocused = true;
                if(e.type == 'blur') this.isFocused = false;
                this.validationMessages = [];
                var rules = this.$props.validationRules || [];
                if(e.target.checkValidity() == false)
                    this.validationMessages.push('Please enter a valid numerical value')
                else{
                    rules.forEach(rule => {
                        switch(rule){
                            case 'required':
                                if(!e.target.value)
                                this.validationMessages.push('This field is required')
                            break;
                        }
                    });
                }

                this.$emit('validate-field', { field: this.$props.name, status: this.valid})
            },
        }
    }
</script>
